import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '../Services/alert';
import { LanguageService } from '../Services/lang';
import { AuthService } from '../Services/auth';
import { UserService } from '../Services/user';
import { OrderService } from '../Services/order';
import { CartService } from '../Services/cart';
import { Address } from '../Models/address';
import { User } from '../Models/user';
import { Order } from '../Models/order';
import { GoogleAnalyticsEventsService } from "../Services/google-analytics";


@Component({
  selector: 'checkout',
  templateUrl: '../Templates/checkout.html',
})


export class CheckoutComponent {

  private _step = 0;
  private _maxStep = 2;
  protected user: User;
  protected address: Address = null;
  protected postalToShipping: boolean = true;

  public createOrderButtonEnabled = true;

  constructor(
    private auth: AuthService,
    private router: Router,
    private alert: AlertService,
    private lang: LanguageService,
    private cartService: CartService,
    private orderService: OrderService,
    private userService: UserService,
    private gaEventsService: GoogleAnalyticsEventsService,
  ) {}

  ngOnInit() {

    this.auth.getUser().subscribe(
      user => {
        this.user = user;

        if ((!this.user) || this.user.is_tmp) {
          this.address = new Address();
          return
        }

        if (this.user._links.address) {
          this.userService.getAddress(this.user).subscribe(
            data => {
              if (!this.address) {
                this.address = new Address();
              }
              this.address.setData(data);
            });
        }
      });
  }

  // create an order, and redirect browser to mollie
  createorder(): void {

    this.createOrderButtonEnabled = false;

    let orderAddress = new Address()
    orderAddress.setData(this.address)
    if (this.postalToShipping) {
      // copy the postal field to the shipping fields
      orderAddress.copyPostalToShipping();
    }

    this.orderService.create(orderAddress).subscribe(data => {
      // redirect to the payment URL
      let order = new Order();
      order.setData(data);

      // notify google analytics about this possible payment
      this.gaEventsService.emitEvent(
        "Checkout",
        "Proceed to payment provider",
        "Clicked on proceed button",
        this.cartService.subtotal()
      );

      location.href = order.payment_redirect_url;
    },
    err => {
      this.createOrderButtonEnabled = true;
      this.alert.error(
        "Couldn't create payment request. Please try again later.");
    });
  }

  saveAddress(address: Address): void {
    this.address = address;
  }

  currentStep(): number {
    return this._step;
  }

  nextStep(): number {
    return this._step++;
  }

  previousStep(): number {
    return this._step--;
  }

  canStepBackward(): boolean {
    return this._step > 0;
  }

  canStepForward(): boolean {
    return this._step < this._maxStep;
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/checkout.ts